const useHelpLink = (): string => {
  return 'https://help.mercuryo.io/hc/en-gb/sections/14494982716829-Getting-started-';
};

export default useHelpLink;
